/* Drift edition motion — scroll reveal (respects prefers-reduced-motion) */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = '.shopify-section > * > .section-content-wrapper > *, .shopify-section .group-block, .shopify-section .product-card, .shopify-section .collection-card, .shopify-section .card, .shopify-section h1, .shopify-section h2, .shopify-section .rte, .shopify-section .button:not(.button-unstyled)';
  function prime(root) {
    var nodes = (root || document).querySelectorAll(SEL);
    var counters = new Map();
    nodes.forEach(function (el) {
      if (el.classList.contains('drift-reveal') || el.closest('media-gallery, header, .header, #header-group, .cart-drawer, dialog, .drift-reveal')) return;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) { el.classList.add('drift-reveal', 'is-visible'); return; }
      var parent = el.parentElement; var n = counters.get(parent) || 0; counters.set(parent, n + 1);
      el.setAttribute('data-drift-delay', String(Math.min(n, 5)));
      el.classList.add('drift-reveal');
      io.observe(el);
    });
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  function speedline() {
    var s = document.createElement('div'); s.className = 'drift-speedline'; document.body.appendChild(s);
    setTimeout(function () { s.remove(); }, 1600);
  }
  function init() { speedline(); prime(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // re-run for content swapped in by the theme's view transitions / section rendering
  document.addEventListener('shopify:section:load', function (e) { prime(e.target); });
  window.addEventListener('pageswap', function () {});
  window.addEventListener('pagereveal', function () { setTimeout(function () { prime(document); }, 50); });
})();
